import { render, staticRenderFns } from "./KegiatanEdit.vue?vue&type=template&id=2cd127ea&scoped=true"
import script from "./KegiatanEdit.vue?vue&type=script&lang=js"
export * from "./KegiatanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd127ea",
  null
  
)

export default component.exports